import { createSharedComposable } from '@vueuse/core'
import { type AutoQaFeedback } from '@zendesk/zqa-services/autoqa'
import { ref } from 'vue'

export enum OmniPanelView {
  REVIEW = 'review',
  FEEDBACK = 'feedback',
  INFO = 'info',
  UNDEFINED = '',
}

const REVIEWS_EXPANDED_STORAGE_KEY = 'zqaAllReviewsExpanded.v1'

export default createSharedComposable(() => {
  const panelView = ref(OmniPanelView.FEEDBACK)
  const allReviewPanelsOpen = ref<boolean>(JSON.parse(localStorage.getItem(REVIEWS_EXPANDED_STORAGE_KEY)) || false)

  const activeFeedbackView = (routeName: string) => {
    if (routeName.includes('message')) {
      return 'message'
    } else if (routeName.endsWith('.dispute')) {
      return 'dispute'
    }

    return undefined
  }

  const setPanelView = (view: OmniPanelView) => {
    panelView.value = view
  }

  const toggleReviewPanel = () => {
    const view = panelView.value === OmniPanelView.REVIEW ? undefined : OmniPanelView.REVIEW
    setPanelView(view)
  }

  const openCollapsibleItemsIds = ref([] as string[])

  const openCollapsiblePanel = (id: string) => {
    if (openCollapsibleItemsIds.value.includes(id)) {
      openCollapsibleItemsIds.value.splice(openCollapsibleItemsIds.value.indexOf(id), 1)
    } else {
      openCollapsibleItemsIds.value.push(id)
    }
  }

  const isCondensedItemPanelCollapsed = (id: string) => {
    return openCollapsibleItemsIds.value.includes(id)
  }

  const toggleAllReviewPanels = (ids: string[]) => {
    if (allReviewPanelsOpen.value) {
      openCollapsibleItemsIds.value = []
      localStorage.setItem(REVIEWS_EXPANDED_STORAGE_KEY, 'false')
    } else {
      openCollapsibleItemsIds.value = ids
      localStorage.setItem(REVIEWS_EXPANDED_STORAGE_KEY, 'true')
    }

    allReviewPanelsOpen.value = !allReviewPanelsOpen.value
  }

  const getAutoQaFeedbackPanelId = (feedback: AutoQaFeedback) => {
    if (!feedback) return null
    if (feedback.transcriptionId) return feedback.transcriptionId
    return feedback.revieweeName || feedback.botRevieweeName
  }

  return {
    panelView,
    activeFeedbackView,
    setPanelView,
    toggleReviewPanel,
    openCollapsiblePanel,
    isCondensedItemPanelCollapsed,
    allReviewPanelsOpen,
    toggleAllReviewPanels,
    openCollapsibleItemsIds,
    getAutoQaFeedbackPanelId,
  }
})
